var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390.523,
    height: 390.526,
    viewBox: "0 0 390.523 390.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M102.519,301.467c0,107.842,87.424,195.266,195.263,195.266s195.26-87.424,195.26-195.266-87.419-195.26-195.26-195.26-195.263,87.421-195.263,195.26",
    transform: "translate(-102.519 -106.207)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(-102.519 -106.207)",
    opacity: 0.138
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(102.519 106.207)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M254.708,263.246a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(130.306 113.816)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M242.292,271.013a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(111.128 125.813)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M247.844,252.274a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(119.704 96.869)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M235.43,260.041a9.532,9.532,0,1,1,13.135,3.026,9.533,9.533,0,0,1-13.135-3.026",
    transform: "translate(100.528 108.866)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M223.013,267.808a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(81.351 120.863)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M253.4,233.536a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(128.278 67.927)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M240.98,241.3a9.533,9.533,0,1,1,13.138,3.025A9.534,9.534,0,0,1,240.98,241.3",
    transform: "translate(109.102 79.924)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M228.565,249.07A9.533,9.533,0,1,1,241.7,252.1a9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(89.926 91.921)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M216.149,256.837a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(70.749 103.917)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M203.734,264.6a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(51.573 115.914)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M191.318,272.371a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(32.395 127.911)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M246.532,222.564a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(117.677 50.98)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M234.116,230.331a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(98.5 62.977)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M221.7,238.1a9.533,9.533,0,1,1,13.138,3.026A9.534,9.534,0,0,1,221.7,238.1",
    transform: "translate(79.324 74.974)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M209.285,245.865a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(60.147 86.97)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M196.87,253.632a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(40.971 98.967)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M184.454,261.4a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(21.793 110.964)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M172.039,269.166a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(2.618 122.96)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M252.083,203.825a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(126.251 22.036)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M239.668,211.592a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(107.076 34.033)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M227.252,219.359a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(87.898 46.03)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M214.837,227.126a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(68.722 58.026)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M202.421,234.893a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(49.545 70.023)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M190.006,242.66a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(30.369 82.02)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M177.592,250.427a9.532,9.532,0,1,1,13.135,3.025,9.535,9.535,0,0,1-13.135-3.025",
    transform: "translate(11.193 94.017)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M165.175,258.194a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-7.984 106.013)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M152.76,265.961a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-27.16 118.01)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M140.344,273.728a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-46.338 130.007)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M257.635,185.086a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(134.827 -6.907)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M245.219,192.853a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(115.649 5.089)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M232.8,200.62a9.533,9.533,0,1,1,13.138,3.025A9.534,9.534,0,0,1,232.8,200.62",
    transform: "translate(96.474 17.086)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M220.388,208.387a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(77.296 29.083)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M207.973,216.154a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(58.12 41.079)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M195.557,223.921a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(38.943 53.076)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M183.142,231.688a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(19.767 65.073)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M170.727,239.455a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(0.591 77.07)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M158.311,247.222a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-18.586 89.066)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M145.9,254.989a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-37.762 101.063)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M133.48,262.756a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-56.94 113.06)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M121.065,270.524A9.533,9.533,0,1,1,134.2,273.55a9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-76.116 125.058)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M250.771,174.114a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(124.225 -23.854)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M238.355,181.881a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(105.047 -11.858)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M225.94,189.648a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(85.872 0.139)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M213.524,197.415a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(66.694 12.136)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M201.109,205.182a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(47.518 24.132)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M188.694,212.95a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(28.342 36.131)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M176.278,220.717a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(9.165 48.127)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M163.863,228.484A9.533,9.533,0,1,1,177,231.51a9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-10.011 60.124)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M151.447,236.251a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-29.188 72.121)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M139.032,244.018a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-48.364 84.117)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M126.616,251.785a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-67.542 96.114)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M114.2,259.552a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-86.717 108.111)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M101.787,267.319a9.533,9.533,0,1,1,13.135,3.025,9.535,9.535,0,0,1-13.135-3.025",
    transform: "translate(-105.893 120.108)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M256.322,155.375A9.533,9.533,0,1,1,269.46,158.4a9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(132.799 -52.798)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M243.907,163.141a9.532,9.532,0,1,1,13.138,3.028,9.531,9.531,0,0,1-13.138-3.028",
    transform: "translate(113.623 -40.8)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M231.492,170.91a9.532,9.532,0,1,1,13.135,3.025,9.535,9.535,0,0,1-13.135-3.025",
    transform: "translate(94.447 -28.803)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M219.076,178.677a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(75.27 -16.807)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M206.661,186.444A9.533,9.533,0,1,1,219.8,189.47a9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(56.094 -4.81)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M194.245,194.211a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(36.916 7.187)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M181.83,201.978A9.533,9.533,0,1,1,194.968,205a9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(17.74 19.184)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M169.414,209.745a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-1.437 31.18)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M157,217.512a9.533,9.533,0,1,1,13.138,3.026A9.534,9.534,0,0,1,157,217.512",
    transform: "translate(-20.613 43.177)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M144.583,225.279a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-39.79 55.174)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M132.168,233.046a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-58.966 67.17)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M119.752,240.813a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-78.144 79.167)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M107.337,248.58a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-97.319 91.164)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M249.458,144.4A9.533,9.533,0,1,1,262.6,147.43a9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(122.197 -69.744)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M237.043,152.171a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(103.021 -57.747)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M224.628,159.938a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(83.845 -45.75)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M212.212,167.705a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(64.668 -33.754)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M199.8,175.472a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(45.492 -21.757)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M187.381,183.239a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(26.314 -9.76)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M174.966,191.006a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(7.139 2.236)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M162.55,198.773a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-12.039 14.233)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M150.135,206.54a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-31.215 26.23)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M137.721,214.307a9.532,9.532,0,1,1,13.135,3.025,9.533,9.533,0,0,1-13.135-3.025",
    transform: "translate(-50.391 38.227)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M125.3,222.074a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-69.568 50.223)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M112.889,229.841a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-88.744 62.22)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M100.473,237.608a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-107.921 74.217)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M255.01,125.665a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(130.772 -98.687)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M242.6,133.432a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(111.597 -86.691)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M230.179,141.2a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(92.419 -74.694)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M217.764,148.966a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(73.243 -62.697)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M205.348,156.733a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(54.066 -50.701)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M192.933,164.5a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(34.89 -38.704)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M180.517,172.267a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(15.712 -26.707)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M168.1,180.034a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-3.463 -14.711)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M155.686,187.8a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-22.641 -2.714)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M143.271,195.568a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-41.817 9.283)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M130.856,203.335a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-60.993 21.279)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M118.44,211.1a9.533,9.533,0,1,1,13.138,3.025A9.534,9.534,0,0,1,118.44,211.1",
    transform: "translate(-80.17 33.276)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M106.025,218.869a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-99.346 45.273)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M248.146,114.693a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(120.17 -115.635)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M235.731,122.46a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(100.995 -103.638)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M223.315,130.227a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(81.817 -91.641)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M210.9,137.994a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(62.641 -79.644)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M198.484,145.761a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(43.464 -67.648)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M186.069,153.528a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(24.288 -55.651)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M173.654,161.3a9.532,9.532,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(5.112 -43.654)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M161.238,169.062a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-14.065 -31.658)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M148.823,176.829a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-33.241 -19.661)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M136.407,184.6a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-52.419 -7.664)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M123.992,192.363a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-71.595 4.332)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M111.576,200.131a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-90.772 16.331)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M99.161,207.9a9.533,9.533,0,1,1,13.138,3.025A9.534,9.534,0,0,1,99.161,207.9",
    transform: "translate(-109.948 28.327)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M216.451,119.255a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(71.215 -108.588)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M204.036,127.022a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(52.039 -96.592)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M191.62,134.789a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(32.862 -84.595)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M179.205,142.557a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(13.686 -72.597)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M166.79,150.322a9.533,9.533,0,1,1,13.138,3.028,9.531,9.531,0,0,1-13.138-3.028",
    transform: "translate(-5.49 -60.6)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M154.374,158.091a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-24.667 -48.603)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M141.959,165.858a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-43.843 -36.606)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M129.543,173.625a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-63.021 -24.61)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M117.128,181.392a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-82.197 -12.613)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M104.712,189.159a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-101.374 -0.616)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M197.172,116.051a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(41.437 -113.537)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M184.757,123.818a9.532,9.532,0,1,1,13.135,3.026,9.535,9.535,0,0,1-13.135-3.026",
    transform: "translate(22.261 -101.54)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M172.341,131.585a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(3.084 -89.544)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M159.926,139.352a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-16.092 -77.547)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M147.51,147.119a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-35.269 -65.55)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M135.1,154.886a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-54.445 -53.554)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M122.679,162.653a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-73.623 -41.557)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M110.264,170.42a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-92.798 -29.56)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M97.848,178.187a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-111.976 -17.563)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M177.893,112.846a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(11.659 -118.487)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M165.477,120.613a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-7.518 -106.491)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M153.062,128.38a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-26.694 -94.494)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M140.646,136.147a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-45.871 -82.497)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M128.231,143.914a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-65.047 -70.501)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M115.817,151.681a9.532,9.532,0,1,1,13.135,3.026,9.533,9.533,0,0,1-13.135-3.026",
    transform: "translate(-84.223 -58.504)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M103.4,159.448a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-103.4 -46.507)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M146.2,117.408a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-37.296 -111.441)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M133.782,125.175A9.533,9.533,0,1,1,146.92,128.2a9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-56.473 -99.444)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M121.367,132.942a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-75.649 -87.448)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M108.952,140.709a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-94.825 -75.451)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M96.536,148.476a9.533,9.533,0,1,1,13.138,3.026,9.534,9.534,0,0,1-13.138-3.026",
    transform: "translate(-114.002 -63.454)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M126.919,114.2a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-67.074 -116.391)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M114.5,121.97A9.533,9.533,0,1,1,127.641,125,9.534,9.534,0,0,1,114.5,121.97",
    transform: "translate(-86.251 -104.395)",
    fill: "#7f01da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M102.088,129.738a9.533,9.533,0,1,1,13.138,3.025,9.534,9.534,0,0,1-13.138-3.025",
    transform: "translate(-105.427 -92.396)",
    fill: "#7f01da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.60f5ef47cc553218c29bbbb76ded2bda.svg";
export { ForwardRef as ReactComponent };